<template>
  <div>
    <b-skeleton-wrapper :loading="loaderValue">
      <!-- Loader -->
      <template #loading>
        <b-skeleton
          v-for="i in 5"
          :key="i"
          width="100%"
          height="7em"
          class="mb-1"
        />
      </template>
      <div>
        <div
          v-if="calendario.length"
          class="business-items"
        >
          <div
            v-for="item in calendario"
            :key="item.id"
            class="business-item"
          >
            <!-- Nombre, edición e indicador de evento exclusivo -->
            <div class="d-flex align-items-center justify-content-between mb-25">
              <!-- Nombre del evento e indicador de evento exclusivo -->
              <div>
                <!-- Indicador de evento exclusivo -->
                <b-badge
                  v-if="item.exclusivo"
                  v-b-tooltip.hover.top="'Evento exclusivo (no será visible para el público, solo roles específicos)'"
                  variant="warning"
                  class="badge-glow mr-75"
                >
                  <feather-icon icon="LockIcon" />
                </b-badge>
                <!-- Nombre de evento -->
                <span class="font-weight-bolder">{{ item.evento }}</span>
              </div>
              <!-- Edición de evento -->
              <div>
                <b-badge
                  v-b-tooltip.hover.top="`Presione para ${tipoSelected.id === item.id ? 'cancelar la edición' : 'modificar los detalles'} de este evento`"
                  :variant="`${tipoSelected.id === item.id ? 'danger' : 'light-primary'}`"
                  class="badge-glow cursor-pointer"
                  @click="tipoSelected.id === item.id ? tipoSelected = {} : tipoSelected = item"
                >
                  <feather-icon :icon="tipoSelected.id === item.id ? 'XIcon' : 'ToolIcon'" />
                  {{ tipoSelected.id === item.id ? 'Cancelar edición' : 'Modificar evento' }}
                </b-badge>
                <!-- Eliminar evento -->
                <feather-icon
                  v-b-tooltip.hover.top="'Presione para borrar el evento'"
                  class="cursor-pointer text-danger ml-50"
                  icon="TrashIcon"
                  @click="deleteEvent(item)"
                />
              </div>
            </div>

            <!-- Descripción -->
            <div class="my-75">
              <small>{{ item.descripcion }}</small>
            </div>

            <!-- Fechas de inicio y fin -->
            <div>
              <!-- Fecha de inicio -->
              <span
                v-b-tooltip.hover.top="`Fecha de inicio (color: ${item.rgbIni ? '#'+item.rgbIni : 'Sin asignar'})`"
                class="badge"
                :class="{ 'badge-light-secondary': !item.rgbIni }"
                :style="item.rgbIni ? `color: #${item.rgbIni} !important; background-color: ${hexToRGB('#'+item.rgbIni, .12)};` : ''"
              >
                {{ timestampToDate(item.fechaIni, 'lll') }}
              </span>
              <!-- Fecha de fin -->
              <span
                v-b-tooltip.hover.top="`Fecha de fin (color: ${item.rgbFin ? '#'+item.rgbFin : 'Sin asignar'})`"
                class="badge ml-50"
                :class="{ 'badge-light-secondary': !item.rgbFin }"
                :style="item.rgbFin ? `color: #${item.rgbFin} !important; background-color: ${hexToRGB('#'+item.rgbFin, .12)};` : ''"
              >
                {{ timestampToDate(item.fechaFin, 'lll') }}
              </span>
            </div>

            <!-- Roles de uso exclusivo -->
            <div v-if="item.exclusivo">
              <!-- Divider -->
              <div class="divider mt-2 mb-1">
                <div class="divider-text">
                  Evento <b>exclusivo</b> para los siguientes roles
                </div>
              </div>
              <!-- Iteración de roles -->
              <div class="card-app-design">
                <div class="design-planning-wrapper">
                  <div
                    v-for="only in item.exclusivo"
                    :key="only.id"
                    class="design-planning p-50"
                  >
                    <small class="mb-0 px-50 font-weight-bolder">
                      {{ only.nombre }}
                      <feather-icon
                        v-b-tooltip.hover="'Remover asignación'"
                        class="text-danger cursor-pointer justify-center"
                        icon="XIcon"
                        size="16"
                        @click="deleteExclusive(only, item.id)"
                      />
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-alert
          v-else
          variant="danger"
          show
        >
          <div class="alert-body text-center">
            <span>No hay eventos asignados a este periodo</span>
          </div>
        </b-alert>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import {
  ref, watch, computed, getCurrentInstance,
} from '@vue/composition-api'
import {
  BBadge,
  VBTooltip,
  BAlert,
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formhttp } from '@core/utils/utils'
import { timestampToDate, hexToRGB } from '@core/utils/filter'
import { saveScheadule } from '../../usePeriodos'

export default {
  components: {
    BBadge,
    BAlert,
    BSkeletonWrapper,
    BSkeleton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    loader: {
      type: Boolean,
      default: false,
    },
    calendario: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const tipoSelected = ref({}) //* Tipo seleccionado
    const toast = useToast()
    const vm = getCurrentInstance().proxy

    watch(() => tipoSelected.value, item => emit('selected-item', item))

    const loaderValue = computed({
      get: () => props.loader,
      set: val => {
        emit('set-loader', val)
      },
    })

    // * Hace llamado POST para borrar exclusividad
    const deleteExclusive = (rol, event) => {
      vm.$swal({
        title: '¿Está seguro de querer remover la exclusividad con el grupo?',
        text: `Esta acción borrará la relación del evento con el grupo "${rol.nombre}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loaderValue.value = true
          saveScheadule({ action: 5, r: rol.id, e: event }).then(response => {
            loaderValue.value = false
            const { icon, label } = formhttp(response.status)
            if (response.status === 200) {
              tipoSelected.value = {}
              emit('reload-data')
            }

            toast({
              component: ToastificationContent,
              props: {
                title: 'Respuesta de solicitud',
                text: response.message,
                icon,
                variant: label,
              },
            },
            { timeout: 8000 })
          }, error => {
            loaderValue.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error en petición [Remover exclusividad]',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
        }
      })
    }

    // * Hace llamado POST para borrar evento
    const deleteEvent = item => {
      vm.$swal({
        title: '¿Está seguro de querer borrar este evento?',
        text: `Esta acción borrará permanente mente el evento "${item.evento}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          loaderValue.value = true
          saveScheadule({ action: 6, x: item.id }).then(response => {
            loaderValue.value = false
            const { icon, label } = formhttp(response.status)
            if (response.status === 200) {
              tipoSelected.value = {}
              emit('reload-data')
            }

            toast({
              component: ToastificationContent,
              props: {
                title: 'Respuesta de solicitud',
                text: response.message,
                icon,
                variant: label,
              },
            },
            { timeout: 8000 })
          }, error => {
            loaderValue.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error en petición [Remover exclusividad]',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          })
        }
      })
    }
    return {
      tipoSelected,
      loaderValue,

      // Methods
      deleteExclusive,
      deleteEvent,

      // Filters
      timestampToDate,
      hexToRGB,
    }
  },
}
</script>
